import React from "react";
import styled from "styled-components";

import { FlexColumnContainer } from "../layout/StyledComponents";
import errorImage from "../../assets/error-not-found.svg";
import { useSanitizedTranslation } from "@trailhead/i18n";
import { Text } from "@trailhead/asurion-ui";

const ErrorContainer = styled(FlexColumnContainer)`
  width: 100%;
  text-align: center;
`;

const Header = styled(Text)<{ hasContact?: boolean; }>`
  text-align: center;
  margin-top: 30px;
  ${({ hasContact }) => `margin-bottom: ${hasContact ? '5' : '30' }px;`}
  line-height: 130%;
`;

const Subheader = styled(Text)`
  line-height: 130%;
`;

const ErrorImage = styled.img`
  margin: 30px auto;
  max-width: 600px;
  text-align: center;
`;

interface ErrorProps {
  message: string;
  contact?: ContactProps;
  styles?: Record<string, string>;
}

type ContactProps = {
  message: string | null | undefined;
  contactNumber: string | null | undefined;
}

const callNumber = (number: string | null | undefined) => {
  if(number) document.location.href = `tel:${number}`
}

const Error: React.FC<ErrorProps> = ({ message, contact, styles }: ErrorProps) => {
  const t = useSanitizedTranslation();
  const hasContact = contact && !!contact.message && !!contact.contactNumber;
  return (
  <ErrorContainer style={styles}>
    <ErrorImage src={errorImage} alt={t("magnifying glass")} />
    <Header size={3} hasContact={hasContact}>{message}</Header>
    {hasContact &&
      <Subheader size={3}>{contact.message} <u onClick={() => callNumber(contact.contactNumber)}>{contact.contactNumber}</u></Subheader>
    }  
  </ErrorContainer>
)};

export default Error;
